// This runs automatically when the module loads
document.addEventListener("click", async (e) => {
  const btn = e.target.closest("[data-add-to-cart]");
  if (!btn) return;
  e.preventDefault();
  await addMeToCart(e, btn);
});

// Local scoped helper function
async function addMeToCart(e, el, quantity = 1) {
  const variantId = el.dataset.variantId || el.dataset.variant_id;
  if (!variantId) {
    console.error("Missing variant ID");
    return;
  }

  el.disabled = true;
  document.dispatchEvent(new CustomEvent("theme:loading:start"));

  try {
    // Prepare sections to be bundled
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    const payload = {
      items: [{ id: Number(variantId), quantity }],
      sections: sectionsToBundle.join(","),
      sections_url: `${window.Shopify.routes.root}variants/${variantId}`,
    };

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(payload),
    });

    // parse response once
    const responseJson = await res.json();

    // if non-2xx, throw with message from body
    if (!res.ok) {
      const errMessage =
        (responseJson && (responseJson.description || responseJson.message)) ||
        "Add to cart failed";
      throw new Error(errMessage);
    }

    // fetch the canonical cart object
    const cartContent = await (
      await fetch(`${Shopify.routes.root}cart.js`)
    ).json();
    cartContent["sections"] = responseJson["sections"];

    // end loading
    document.dispatchEvent(new CustomEvent("theme:loading:end"));

    // tell theme a variant was added (data shape you already use)
    document.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          variant: variantId,
          quantity,
          items: Array.isArray(responseJson.items)
            ? responseJson.items
            : [responseJson],
          cart: cartContent,
        },
      }),
    );

    // preferred: trigger a generic cart refresh event so theme code can fetch/render sections
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true }),
    );

    // also emit cart:change (if your theme relies on it)
    document.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "variant:add", cart: cartContent },
      }),
    );
  } catch (err) {
    document.dispatchEvent(new CustomEvent("theme:loading:end"));
    document.dispatchEvent(
      new CustomEvent("cart:error", { detail: { message: err.message } }),
    );
    console.error(err);
  } finally {
    el.disabled = false;
  }
}

// Initialize tabs functionality
function initTabs() {
  document.querySelectorAll(".TabNav__Button").forEach((btn) => {
    btn.addEventListener("click", () => {
      document
        .querySelectorAll(".TabNav__Button")
        .forEach((b) => b.classList.remove("active"));
      document
        .querySelectorAll(".TabContent")
        .forEach((tab) => tab.classList.remove("active"));
      btn.classList.add("active");
      document.getElementById(btn.dataset.tab).classList.add("active");
    });
  });
}

// Initialize modal functionality
function initModal() {
  const modal = document.querySelector(".myModal");
  const btns = document.querySelectorAll(".myBtn");
  const span = document.getElementsByClassName("close")[0];
  const header = document.querySelector("header");

  if (!modal || !btns.length || !span) return;

  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      modal.style.display = "block";
      header.style.zIndex = "1";
    });
  });

  span.addEventListener("click", () => {
    modal.style.display = "none";
    header.style.zIndex = "";
  });

  window.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.style.display = "none";
      header.style.zIndex = "";
    }
  });
}
function LayersToggle() {
  function initHoverGroup(rootSelector, itemSelector) {
    const root = rootSelector ? document.querySelector(rootSelector) : document;
    if (!root) return;

    const items = root.querySelectorAll(itemSelector);
    if (!items.length) return;

    items.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        // disable and remove active from all items in this group
        items.forEach((i) => {
          i.classList.add("disable--layer");
          i.classList.remove("active--layer");
        });

        // activate hovered item (also remove disable so it stands out)
        item.classList.remove("disable--layer");
        item.classList.add("active--layer");
      });
    });
  }

  // init hover groups (keeps behavior local to group)
  initHoverGroup(".Layers--Grid", ".hover--expend");
  initHoverGroup(null, ".hover--expended"); // use document as root

  // Event delegation for clicks (fewer listeners, works for dynamic DOM too)
  document.addEventListener("click", (event) => {
    // .main_flip click — toggle .flip_active on closest element that has active--layer
    const clickedFlip = event.target.closest(".main_flip");
    if (clickedFlip) {
      const parent = clickedFlip.closest(".active--layer");
      if (parent) parent.classList.toggle("flip_active");
      return; // optional: stop further processing if only one action expected
    }

    const toggler = event.target.closest(".show_Text, .show_less");
    if (toggler) {
      const parent = toggler.closest(".show_more");
      if (parent) parent.classList.toggle("show_more_active");
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initTabs();
  initModal();
  LayersToggle();
});
